import { FC } from 'react';
import { styled } from '@material-ui/core';

type Props = {
  url: string | null;
  id: string;
  marginTop: string;
  marginLeft: string;
  className?: string;
};

const IframePage: FC<Props> = ({ url, id, marginTop, marginLeft, className }) => {
  const Iframe = styled('iframe')({
    width: `calc(100vw - 302px)`,
    height: '100%',
    marginTop: marginTop,
    marginLeft: marginLeft,
    overflow: 'hidden',
    borderWidth: '0px',
    position: 'fixed',
  });

  return url ? <Iframe className={className} id={id} src={url} /> : null;
};

export default IframePage;
